export const SPECIAL_MENTOR_ID = "13634849";

export const organizationTreeDemoPersons = [
  { documentId: "demo-01", personId: SPECIAL_MENTOR_ID, name: "Ariana Popa", assignedTo: "None", type: "Administrator", rank: "Diamond", createdAt: "2025-01-10T09:00:00.000Z" },
  { documentId: "demo-02", personId: "22001401", name: "Maria Ionescu", assignedTo: SPECIAL_MENTOR_ID, type: "Lider", rank: "Platinum", createdAt: "2025-02-12T10:30:00.000Z" },
  { documentId: "demo-03", personId: "22001402", name: "Elena Dumitrescu", assignedTo: SPECIAL_MENTOR_ID, type: "Lider", rank: "Gold", createdAt: "2025-02-20T11:00:00.000Z" },
  { documentId: "demo-04", personId: "22001403", name: "Andreea Matei", assignedTo: SPECIAL_MENTOR_ID, type: "Consultant", rank: "Gold", createdAt: "2025-03-04T14:20:00.000Z" },
  { documentId: "demo-05", personId: "22001404", name: "Ioana Stan", assignedTo: "22001401", type: "Consultant", rank: "Silver", createdAt: "2025-03-18T08:45:00.000Z" },
  { documentId: "demo-06", personId: "22001405", name: "Roxana Pavel", assignedTo: "22001401", type: "Consultant", rank: "Silver", createdAt: "2025-04-02T12:10:00.000Z" },
  { documentId: "demo-07", personId: "22001406", name: "Cristina Radu", assignedTo: "22001402", type: "Consultant", rank: "Silver", createdAt: "2025-04-17T09:25:00.000Z" },
  { documentId: "demo-08", personId: "22001407", name: "Simona Enache", assignedTo: "22001402", type: "Consultant", rank: "Bronze", createdAt: "2025-05-06T16:00:00.000Z" },
  { documentId: "demo-09", personId: "22001408", name: "Diana Georgescu", assignedTo: "22001403", type: "Consultant", rank: "Bronze", createdAt: "2025-05-23T10:15:00.000Z" },
  { documentId: "demo-10", personId: "22001409", name: "Oana Marinescu", assignedTo: "22001403", type: "Membru", rank: "Bronze", createdAt: "2025-06-11T13:40:00.000Z" },
  { documentId: "demo-11", personId: "22001410", name: "Alexandra Neagu", assignedTo: "22001404", type: "Membru", rank: "Bronze", createdAt: "2025-07-01T09:50:00.000Z" },
  { documentId: "demo-12", personId: "22001411", name: "Bianca Tudor", assignedTo: "22001404", type: "Membru", rank: "Basic", createdAt: "2025-08-14T15:30:00.000Z" },
  { documentId: "demo-13", personId: "22001412", name: "Laura Ilie", assignedTo: "22001405", type: "Membru", rank: "Basic", createdAt: "2025-09-03T11:05:00.000Z" },
  { documentId: "demo-14", personId: "22001413", name: "Gabriela Dinu", assignedTo: "22001405", type: "Membru", rank: "Basic", createdAt: "2025-09-22T12:35:00.000Z" },
  { documentId: "demo-15", personId: "22001414", name: "Nicoleta Pop", assignedTo: "22001406", type: "Membru", rank: "Basic", createdAt: "2025-10-09T08:20:00.000Z" },
  { documentId: "demo-16", personId: "22001415", name: "Raluca Munteanu", assignedTo: "22001406", type: "Membru", rank: "Basic", createdAt: "2025-11-18T14:45:00.000Z" },
  { documentId: "demo-17", personId: "22001416", name: "Alina Preda", assignedTo: "22001407", type: "Membru", rank: "Basic", createdAt: "2026-01-16T10:00:00.000Z" },
  { documentId: "demo-18", personId: "22001417", name: "Denisa Lupu", assignedTo: "22001408", type: "Membru", rank: "Basic", createdAt: "2026-03-05T09:15:00.000Z" },
  { documentId: "demo-19", personId: "22001418", name: "Mirela Sava", assignedTo: "22001409", type: "Membru", rank: "Basic", createdAt: "2026-05-21T13:10:00.000Z" },
  { documentId: "demo-20", personId: "22001419", name: "Carmen Petrescu", assignedTo: "22001410", type: "Membru", rank: "Basic", createdAt: "2026-07-18T17:25:00.000Z" },
];

export const organizationTreeDemoAnalytics = {
  basicMetrics: {
    totalUsers: 20,
    activeUsers: 17,
    newUsers: 4,
    totalVideos: 28,
    totalViews: 1842,
    completedVideos: 316,
    totalFavorites: 438,
    totalWatchLater: 126,
    engagementRate: 85,
    completionRate: 72,
  },
  userMetrics: {
    rankDistribution: {
      Diamond: 1,
      Platinum: 1,
      Gold: 2,
      Silver: 3,
      Bronze: 4,
      Basic: 9,
    },
  },
  contentMetrics: {
    categoryStats: {
      Wellness: { count: 8, views: 612 },
      Emoții: { count: 6, views: 483 },
      Imunitate: { count: 5, views: 401 },
      Business: { count: 4, views: 231 },
      Ritualuri: { count: 5, views: 115 },
    },
  },
  activityMetrics: {
    totalActivity: 428,
    dailyActivity: [
      { date: "2026-07-23", activity: 42 },
      { date: "2026-07-24", activity: 58 },
      { date: "2026-07-25", activity: 47 },
      { date: "2026-07-26", activity: 71 },
      { date: "2026-07-27", activity: 66 },
      { date: "2026-07-28", activity: 79 },
      { date: "2026-07-29", activity: 65 },
    ],
  },
  detailedData: {
    recentUsers: organizationTreeDemoPersons.slice(-6).reverse().map((person) => ({
      id: person.documentId,
      displayName: person.name,
      email: "date-demo@theoilsbabe.ro",
      rank: person.rank,
      createdAt: person.createdAt,
    })),
    topVideos: [
      { id: "video-01", title: "Introducere în aromaterapie", category: "Wellness", viewCount: 284 },
      { id: "video-02", title: "Rutina de seară pentru echilibru", category: "Ritualuri", viewCount: 239 },
      { id: "video-03", title: "Gestionarea emoțiilor", category: "Emoții", viewCount: 211 },
      { id: "video-04", title: "Sprijin pentru imunitate", category: "Imunitate", viewCount: 196 },
    ],
  },
};
